import { DateRange } from "@mui/x-date-pickers-pro";
import { Dayjs } from "dayjs";
import {
  Controller,
  FieldValues,
  FieldPath,
  useFormContext,
} from "react-hook-form";

import DateRangePicker from "./DateRangePicker";
import { DateRangePickerHookFormProps } from "./DateRangePicker.types";

const DateRangePickerHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  ...innerProps
}: DateRangePickerHookFormProps<TFieldValues, TName>) => {
  const { control } = useFormContext<TFieldValues>();
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = errors[name] as unknown as Array<Record<string, unknown>>;
        const errorMsg = error?.[0]?.message ?? error?.[1]?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <DateRangePicker
            {...innerProps}
            {...innerField}
            inputRef={ref}
            error={!!error}
            helperText={helperText}
            disabled={
              typeof disabled === "boolean" ? disabled : innerProps.disabled
            }
            onChange={onChange as unknown as (event: DateRange<Dayjs>) => void}
            {...(setPropsWithFormState?.(formState) ?? {})}
          />
        );
      }}
    />
  );
};

export default DateRangePickerHookForm;
